import { Outlet } from 'react-router-dom';
// @mui
import { Container } from '@mui/material';

// ----------------------------------------------------------------------

export default function CompactLayout() {
  return (
    <Container 
      component="main" 
      maxWidth="lg"
      sx={{
        py: 3,
        minHeight: '100vh',
      }}
    >
      <Outlet />
    </Container>
  );
}
